import { colors, fonts, themeColors } from "@/stylingConstants";
import { ButtonVariant } from "./CustomLinkButton";
import React from 'react';

export type BaseButtonType = {
  isDisabled?: boolean;
  children: React.ReactNode;
  extraButtonClasses?: string;
  variant?: ButtonVariant;
  leftIcon?: React.JSX.Element;
  rightIcon?: React.JSX.Element;
  extraStyles?: React.CSSProperties;
  extraDisabledStyles?: React.CSSProperties;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const CustomButton = ({ 
    children,
    isDisabled,
    variant=ButtonVariant.Primary,onClick,
    rightIcon,
    leftIcon,
    extraStyles={},
    extraButtonClasses,
    extraDisabledStyles={},
    ...props
  }:BaseButtonType) => {

    const getBackgroundClasses = () => {
    if (isDisabled) {
      return "bg-gray-300 cursor-not-allowed";
    }
    if (variant === "primary") {
      return `bg-brightCambridgeBlue hover:bg-CambridgeBlue_50 hover:text-white active:bg-darkCambridgeBlue active:text-white 
      focus:bg-CambridgeBlue_50 focus:text-white focus:border-2 focus-multiple-shadows`;
    }
    if (variant === "secondary") {
      return `bg-white border-2 border-brightCambridgeBlue text-CambridgeBlue_50
      hover:border-semiDarkCambridgeBlue hover:text-semiDarkCambridgeBlue
      active:border-darkCambridgeBlue active:text-darkCambridgeBlue
      focus:border-semiDarkCambridgeBlue focus:text-semiDarkCambridgeBlue
      focus-multiple-shadows`;
    }
    return `bg-transparent text-CambridgeBlue_50 
    hover:text-semiDarkCambridgeBlue active:text-darkCambridgeBlue focus:text-semiDarkCambridgeBlue focus-multiple-shadows`;
  };

  const backgroundClasses = getBackgroundClasses();

const disabledStyles = variant === 'secondary' 
  ? {
      backgroundColor: themeColors.adult.cupGeneralColor1,
      color: colors.gray2,
      border: `2px solid ${colors.gray2}`,
      cursor: 'not-allowed',
      ...extraDisabledStyles
    }
  : {
      backgroundColor: colors.gray3,
      color: colors.gray2,
      border: 'none',
      cursor: 'not-allowed',
      ...extraDisabledStyles
    };
  return (
    <button
            disabled={isDisabled || false}
            onClick={onClick}
            style={{
                width: '100%',
                flexGrow:1,
                margin: '0',
                padding: '16px 24px',
                borderRadius: '5px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                whiteSpace:'nowrap',
                maxHeight:56,
                ...fonts.button,
                ...extraStyles,
                ...isDisabled ? disabledStyles : {},
            }}
            className={`${backgroundClasses} ${extraButtonClasses ?? ''}`}
            {...props}
        >
            {leftIcon && <span style={{ marginRight: '8px' }}>{leftIcon}</span>}
            {children}
            {rightIcon && <span style={{ marginLeft: '8px' }}>{rightIcon}</span>}
        </button>
  );
};

export default CustomButton;